import * as actionTypes from "../../../constants/ActionTypes/AdminPortal/AdminUsers";

const initialState = {
    data: {},
    loading: false,
    success: false,
    error: null,
    isSubmitEnabled: false
}

const AdminUser_VALIDATE = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ADMIN_USERS_VALIDATE_INIT:
            return {
                ...state,
                loading: true,
                success: false,
                isSubmitEnabled: false
            }
        
        case actionTypes.ADMIN_USERS_VALIDATE_SUCCESS:
            return {
                ...state,
                data: action.data,
                loading: false,
                error: null,
                success: true,
                isSubmitEnabled: true
            }
        
        case actionTypes.ADMIN_USERS_VALIDATE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.message,
                success: false,
                data: {},
                isSubmitEnabled: false
            }
        
        case actionTypes.ADMIN_USERS_VALIDATE_RESET:
            return {
                ...state,
                loading: false,
                error: null,
                success: false,
                data: {},
                isSubmitEnabled: false
            }
        
        default:
            return {...state}
    }
}

export default AdminUser_VALIDATE